import type { Components } from "@mui/material";

export const MuiTabsThemeOptions: Components["MuiTabs"] = {
  styleOverrides: {
    indicator: {
      height: 5,
    },
  },
};
